import { ACTION } from './constants';
import request from '../../../../../utils/request';
import { requestConfig } from '../../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../../actions';

export function getSipBannerContent() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getSipBannerContent())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_SIP_BANNER_CONTENT, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with SIP Banner API: " + error)
            });
    }
}

export function getSipDisclaimerContent() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getSipDisclaimerContent())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_SIP_DISCLAIMER_CONTENT, data: json });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with SIP Disclaimer API: " + error)
            });
    }
}

export function postSipCallUs(formdata) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.postSipCallUs(formdata))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.POST_SIP_CALL_US, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with SIP Call Us Api: " + error)
            });
    }
}